import Image from 'next/image'
import { createImageUrl } from '@/utils/image/create-image-url'
import { run } from '@/utils/run'
import { cn } from '@/utils/styles/cn'

interface IRestaurantDetailImageProps {
    index?: number
    isDuplicate?: boolean
    url: string
    makeRef: (index: number) => (el: HTMLDivElement) => void
    imageWidth: number
    imageHeight: number
    imageContainerHeight: number
    imageContainerWidth: number
    forceMobileView?: boolean
}

export const RestaurantDetailImage = ({
    index,
    isDuplicate,
    url,
    makeRef,
    imageHeight,
    imageWidth,
    imageContainerHeight,
    imageContainerWidth,
    forceMobileView = false,
}: IRestaurantDetailImageProps) => {
    const actualIndex = index

    return (
        <div
            ref={typeof actualIndex === 'number' ? makeRef(actualIndex) : undefined}
            className={cn(
                'restaurant-detail-images-image-container--mobile bg-bg-neutral-base md:bg-bg-neutral-surface',
                !forceMobileView && 'md:restaurant-detail-images-image-container--desktop',
                isDuplicate && 'hidden md:block'
            )}
        >
            {run(() => {
                if (imageWidth === 0 || imageHeight === 0) return null

                return (
                    <Image
                        unoptimized
                        priority={typeof actualIndex === 'number' && actualIndex < 3}
                        src={createImageUrl(url!, {
                            height: imageHeight,
                            width: imageWidth,
                        })}
                        height={imageHeight}
                        width={imageWidth}
                        alt="Restaurant image"
                        style={{
                            height: imageContainerHeight,
                            minHeight: imageContainerHeight,
                            maxHeight: imageContainerHeight,
                            width: imageContainerWidth,
                            minWidth: imageContainerWidth,
                            maxWidth: imageContainerWidth,
                        }}
                        className="bg-bg-neutral-surface md:w-full md:min-w-full w-[100vw] min-w-[100vw] h-full object-cover object-center"
                    />
                )
            })}
        </div>
    )
}
